import CardSection from '../sections/CardSection';
import SelectField from '../form/SelectField';
import InputField  from '../form/InputField';

export default function ContactSection({
    data,
    paises,
    municipios,
    onChange,
    errors
}) {
    const paisesOptions = Array.isArray(paises)
        ? paises.map(item => ({ 
            value: item.codigo, 
            label: item.descripcion 
        }))
        : [];

    const municipiosOptions = Array.isArray(municipios)
        ? municipios.map(item => ({ 
            value: item.codigo,
            label: item.descripcion 
        }))
        : [];

    return (
        <CardSection icon="public" title="Contacto y Ubicación">
            <div className="row">
                <div className="col-md-6">
                    <SelectField
                        id="pais"
                        label="País"
                        options={paisesOptions}
                        value={data.pais}
                        onChange={onChange}
                        required
                        error={errors.pais}
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-6">
                    <SelectField
                        id="municipio"
                        label="Ciudad de Residencia"
                        options={municipiosOptions}
                        value={data.municipio}
                        onChange={onChange}
                        required
                        error={errors.municipio}
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-6">
                    <InputField
                        id="direccion"
                        label="Dirección"
                        placeholder="Calle 123 #45-67"
                        value={data.direccion}
                        onChange={onChange}
                        required
                        error={errors.direccion}
                    />
                </div>
                <div className="col-md-6">
                    <InputField
                        id="celular"
                        label="Celular"
                        placeholder="3001234567"
                        value={data.celular}
                        onChange={onChange}
                        required
                        error={errors.celular}
                    />
                </div>
                <div className="col-md-6">
                    <InputField
                        id="email"
                        label="E-mail"
                        type="email"
                        placeholder="correo@dominio.com"
                        value={data.email}
                        onChange={onChange}
                        required
                        error={errors.email}
                    />
                </div>
                <div className="col-md-6">
                    <InputField
                        id="telefonoFijo"
                        label="Teléfono fijo"
                        placeholder="Opcional"
                        value={data.telefonoFijo}
                        onChange={onChange}
                        error={errors.telefonoFijo}
                    />
                </div>
            </div>
        </CardSection>
    );
}
